import axios from 'axios'
import { Decode } from '@/services'
import { mapCartResponse } from '@/services/cartResponse'

const IsCheckoutPaymentSummary = () => {
  return window.location.pathname.replace(/\/+$/, '') === '/checkout-payment-summary'
}

const GetToken = () => {
  const headers = { 'Content-Type': 'application/json' }
  const checkoutAuthMode = sessionStorage.getItem('checkout_auth_mode')
  const isMagicLinkCheckout = IsCheckoutPaymentSummary() &&
    checkoutAuthMode === 'magic_link' &&
    sessionStorage.getItem('checkout_token_active') === 'true'

  if (isMagicLinkCheckout) {
    const checkoutAccessToken = sessionStorage.getItem('checkout_access_token')

    if (checkoutAccessToken) {
      headers.Authorization = `Bearer ${checkoutAccessToken}`
    }
  } else if (localStorage.getItem('oneData') !== null) {
    try {
      const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))

      if (oneData.user && oneData.user.access_token) {
        headers.Authorization = `Bearer ${oneData.user.access_token}`
      }
    } catch (error) {
      // A checkout magic link does not require the regular login token.
    }
  }

  return { headers }
}

const GetUserToken = () => {
  const headers = {}

  if (localStorage.getItem('oneData') !== null) {
    try {
      const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))

      if (oneData.user && oneData.user.access_token) {
        headers.Authorization = `Bearer ${oneData.user.access_token}`
      }
    } catch (error) {
      // The API will return an authorization error when the saved login is invalid.
    }
  }

  return { headers }
}

export default {
  async ListPickupAddresses (data) {
    const auth = GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/list_pickup_address_v3`, data, auth)
      return response.data
    } catch (error) {
      return error.response
        ? { ...error.response.data, http_status: error.response.status }
        : { status: 'error', transport_error: true, message: error.message }
    }
  },
  async ListProductOptionsV3 (data) {
    const auth = GetUserToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/list_product_options_v3`, { cart_hash: data.cart_hash }, auth)
      return response.data
    } catch (error) {
      return error.response
        ? { ...error.response.data, http_status: error.response.status }
        : { status: 'error', transport_error: true, message: error.message }
    }
  },
  async ChangeProductOptionV3 (data) {
    const auth = GetUserToken()
    auth.headers['Idempotency-Key'] = data.idempotencyKey
    const payload = {
      cart_hash: data.payload.cart_hash,
      product_attribute_id: data.payload.product_attribute_id,
      expected_cart_version: data.payload.expected_cart_version
    }
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/change_product_option_v3`, payload, auth)
      return response.data
    } catch (error) {
      return error.response
        ? { ...error.response.data, http_status: error.response.status }
        : { status: 'error', transport_error: true, message: error.message }
    }
  },
  async VerifyCheckoutToken (data) {
    const auth = await GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/verify_checkout_token_v3`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  },
  async GenerateCartLinkV3 (data) {
    const auth = GetUserToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_BACK_END}api/generate_cart_link_v3`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  },
  async DeleteProductInCartV3 (data) {
    const auth = GetUserToken()
    auth.headers['Content-Type'] = 'application/json'
    auth.headers['Idempotency-Key'] = data.idempotencyKey
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/delete_product_in_cart_v3`, data.payload, auth)
      return response.data
    } catch (error) {
      return error.response
        ? { ...error.response.data, http_status: error.response.status }
        : { status: 'error', transport_error: true, message: error.message }
    }
  },
  async ListUserAddressUPS () {
    const auth = await GetToken()
    try {
      const response = await axios.get(`${process.env.VUE_APP_BACK_END}api/list_user_address_ups`, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  },
  async GetDetailCart (data) {
    const auth = await GetToken()
    if (data.idempotencyKey) {
      auth.headers['Idempotency-Key'] = data.idempotencyKey
    } else {
      const operationId = new Uint8Array(16)
      window.crypto.getRandomValues(operationId)
      auth.headers['Idempotency-Key'] = Array.from(operationId, byte => byte.toString(16).padStart(2, '0')).join('')
    }
    const payload = { ...(data.payload || data) }
    delete payload.company_position
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/calculate_cart_v3`, payload, auth)
      return mapCartResponse(response.data)
    } catch (error) {
      if (error.response && error.response.data) {
        return { ...error.response.data, http_status: error.response.status }
      }
      return {
        status: 'error',
        transport_error: true,
        message: error.message
      }
    }
  },
  async StartCheckout (data) {
    const auth = await GetToken()
    auth.headers['Idempotency-Key'] = data.idempotencyKey
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/checkout`, data.payload, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return { ...error.response.data, http_status: error.response.status }
      }
      return {
        status: 'error',
        transport_error: true,
        message: error.message
      }
    }
  },
  async GetCheckoutCart (data) {
    const auth = GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/detail_cart_v3`, data, auth)
      return mapCartResponse(response.data)
    } catch (error) {
      return error.response
        ? { ...error.response.data, http_status: error.response.status }
        : { status: 'error', transport_error: true, message: error.message }
    }
  },
  async ListCheckoutCoupons (data) {
    const auth = GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/list_select_coupon`, data, auth)
      return response.data
    } catch (error) {
      return error.response
        ? { ...error.response.data, http_status: error.response.status }
        : { status: 'error', transport_error: true, message: error.message }
    }
  },
  async PrepareCheckout (data) {
    const auth = await GetToken()
    auth.headers['Idempotency-Key'] = data.idempotencyKey
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/calculate_cart_v3`, data.payload, auth)
      return mapCartResponse(response.data)
    } catch (error) {
      if (error.response && error.response.data) {
        return { ...error.response.data, http_status: error.response.status }
      }
      return {
        status: 'error',
        transport_error: true,
        message: error.message
      }
    }
  },
  async GenerateQuotationExample (data) {
    const auth = await GetToken()
    auth.timeout = 45000
    try {
      // Each successful request creates a document; do not retry automatically.
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/quotation_preview`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return { ...error.response.data, http_status: error.response.status }
      }
      return {
        status: 'error',
        transport_error: true,
        message: error.message
      }
    }
  },
  async CreateOrderV3 (data) {
    const auth = await GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_BACK_END}api/create_order_v3`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  },
  async ConfirmCheckout (data) {
    const auth = await GetToken()
    auth.headers['Idempotency-Key'] = data.idempotencyKey
    try {
      const response = await axios.post(`${process.env.VUE_APP_DOMAIN}api/cart/api/confirm`, data.payload, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return { ...error.response.data, http_status: error.response.status }
      }
      return {
        status: 'error',
        transport_error: true,
        message: error.message
      }
    }
  },
  async ReadyShopCoupon (data) {
    const auth = await GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_BACK_END2}coupon/readyV2_web`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  },
  async ReadyPlatformCoupon (data) {
    const auth = await GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_BACK_END2}platform/coupon/readyV2_web`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  },
  async EstimateCostByProduct (data) {
    const auth = await GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_BACK_END}api/estimate_cost_by_product`, data, auth)
      return response.data
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return {
        status: 'error',
        message: error.message
      }
    }
  }
}
